import { Text } from "../../../../packages/ui-kit";
import { DICTIONARY } from "../../dictionary";
import emptyChatPic from "./images/empty-chat-icon.svg";
import styles from "./chat-empty.module.scss";

const LOCALE = DICTIONARY.CHAT_EMPTY;

export const ChatEmpty = () => {
  const image = (
    <img
      data-test-id="chat-empty-stub-img"
      className={styles.icon}
      src={emptyChatPic}
      alt={LOCALE.TITLE}
    />
  );

  const title = (
    <Text
      dataTestId="chat-empty-stub-title"
      className={styles.title}
      size="large"
      weight="medium"
    >
      {LOCALE.TITLE}
    </Text>
  );

  const subtitle = (
    <Text dataTestId="chat-empty-stub-subtitle" className={styles.subtitle}>
      {LOCALE.SUB_TITLE}
    </Text>
  );

  return (
    <div data-test-id="chat-empty-stub" className={styles["chat-empty"]}>
      <div className={styles.banner}>
        {image}
        {title}
        {subtitle}
      </div>
    </div>
  );
};
